import { StyleSheet, Platform } from "react-native";
import AppTheme from "../../../AppTheme";

const timeStyles = StyleSheet.create({
  container: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: -7,
    minHeight: 8,
  },
  border: {
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
    marginLeft: 30,
  },
  timeContainer: {
    position: "absolute",
    left: 0,
    top: -8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    minWidth: 42,
    width: "auto",
    backgroundColor: "transparent",
    zIndex: 10,
    borderRadius: 10,
  },
  time: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
    opacity: 0.5,
    paddingRight: 2,
  },
  meridian: {
    position: "absolute",
    left: "85%",
    top: 4,
    fontSize: 7,
    lineHeight: 9,
    fontWeight: "600",
    letterSpacing: 0.175,
    color: "#2D3142",
    opacity: 0.5,
    marginLeft: 2,
    paddingRight: 2,
  },
  enabledTime: {
    color: AppTheme.DEFAULT_COLOR,
    opacity: 1,
  },
});

export default timeStyles;
